import Option from "./option";
import CompanyLicense from "./companyLicense";
import FileVM from "./fileVM";

export enum Applications {
  Admin = 1,
  Detector,
  Gmd,
  Responder,
  Investigator,
}

export default interface Application {
  id: number;
  name: string;
  title?: string;
  description?: string;
  enabled: boolean;
  url: string;
  companyLicenses?: CompanyLicense[];
  roles?: Option[];
  logo?: FileVM;
}
